import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { StoreModule } from '@ngrx/store';

import * as fromFavorites from './+state/favorites.reducer';
import { FavoritesEffects } from './+state/favorites.effects';
import { FavoritesFacade } from './+state/favorites.facade';
import { FavoritesService } from './favorites.service';

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        StoreModule.forFeature(fromFavorites.FAVORITES_FEATURE_KEY, fromFavorites.favoritesReducer)
    ],
    providers: [FavoritesFacade, FavoritesService, FavoritesEffects]
})
export class FavoritesModule {}
